import { render, staticRenderFns } from "./SecretSelector.vue?vue&type=template&id=6b45bc81&"
import script from "./SecretSelector.vue?vue&type=script&lang=js&"
export * from "./SecretSelector.vue?vue&type=script&lang=js&"
import style0 from "./SecretSelector.vue?vue&type=style&index=0&id=6b45bc81&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports